import React, { useContext, useEffect, useRef, useState } from "react";
import { DCTextArea } from "../Wrappers/DCTextArea";
import { LogPageNumberInput } from "../LogPageNumberInput/LogPageNumberInput";
import { DefectReport } from "../../Model/DefectReport";
import { TraxLogInfoReport } from "../TraxLogInfoReport/TraxLogInfoReport";
import "./TraxLogInfo.scss";
import { DCInput } from "../Wrappers/DCInput";
import { AuthContext } from "../../providers/AuthProvider";

interface TraxLogInfoProps {
  mechanicalfailindInput: string;
    showLoader: boolean;
    compareInProgress?: boolean;
    logPageNumberInput: string;
    itemNumberInput?: string;
    isNon737Tail?: boolean;
    ataChapterInput: string;
    discrepancyCommentsInput: string;
    correctioncommentsInput: string;
    fleetInput: string;
    traxFlightNumberInput: string;
    manufacturer: string;
    logValidationChanged: (isValid: boolean) => void;
    logPageNumberChanged: (logPageNumber: string) => void;
    onLogFocusChanged?: (isFocused: boolean) => void;
    itemNumberChanged?: (itemNumber: string) => void;
    onItemFocusChanged?: (isFocused: boolean) => void;
    ataChapterChanged: (atachapter: string) => void;
    discrepancycommentsChanged: (discrepancycomments: string) => void;
    correctioncommentsChanged: (correctioncomments: string) => void;
    traxFlightNumberChanged: (traxFlightNumber: string) => void;
    traxDataMismatch: boolean;
    onClearTraxMismatch?: () => void;
    onRefreshComplete?: () => void;
    isLogPageValid: boolean;
    onClickSave?: boolean;
    defectType: string;
    defectTypeChanged?: (defectType: string) => void;
}

type LogPageNumberInputHandle = {
  refresh: () => void;
};

// Width of the non-737 Item number field; also used to offset the left/right flex column balance.
const ITEM_FIELD_WIDTH = '4.5rem';

 export const TraxLogInfo = ({
        showLoader, 
   compareInProgress = false,
        mechanicalfailindInput,
        logPageNumberInput,
        itemNumberInput = '',
   isNon737Tail = false,
        ataChapterInput, 
        discrepancyCommentsInput, 
        correctioncommentsInput,
        fleetInput,
        traxFlightNumberInput,
        logValidationChanged,
        logPageNumberChanged,
        onLogFocusChanged,
        itemNumberChanged,
        onItemFocusChanged,
        ataChapterChanged,
        discrepancycommentsChanged,
        correctioncommentsChanged,
        traxFlightNumberChanged,
        traxDataMismatch,
        onClearTraxMismatch,
        onRefreshComplete,
        manufacturer,
        isLogPageValid,
        onClickSave,
        defectType,
        defectTypeChanged
      }: TraxLogInfoProps) => {
    
    //States
    const {
    getAccessToken,
    getAdminStatus,
    getMaintainerStatus,
  } = useContext(AuthContext);
    const [loading, setLoading] = useState(showLoader);
    const [busy, setBusy] = useState(false);
    const [logPageNumber, setLogPageNumber] = useState(logPageNumberInput);
    const [itemNumber, setItemNumber] = useState(itemNumberInput);
    const [atachapter, setAtachapter] = useState(ataChapterInput);
    const [discrepancycomments, setDiscrepancyComments] = useState(discrepancyCommentsInput);
    const [correctioncomments, setCorrectionComments] = useState(correctioncommentsInput);
    const [mechanicalfailind, setMechanicalfailind] = useState(mechanicalfailindInput);
    const [fleet, setFleet] = useState(fleetInput);
    const [traxFlightNumber, setTraxFlightNumber] = useState(traxFlightNumberInput);
    const [isTraxDataMismatch, setIsTraxDataMismatch] = useState(false);
    const [manufacturerInput,setManufacturerInput] = useState(manufacturer);
    const [isLogNoValid,setIsLogNoValid] = useState(true);
    const hasAutoRefreshedExistingRecordRef = useRef(false);
    const isAutoRefreshInProgressRef = useRef(false);
    const isManualRefreshInProgressRef = useRef(false);
    const isUserClearingMismatchRef = useRef(false);
    // Tracks the last validated log page number so we can detect actual edits
    // vs. simple focus/blur without changes (which should NOT hydrate/kill orange).
    const lastValidatedLogRef = useRef(logPageNumberInput);
    const isNon737TailMountedRef = useRef(false);
    const prevLoadingRef = useRef(showLoader);

    // isNon737Tail=true means non-737 (HA tail), isNon737Tail=false means 737
    const isNon737Aircraft = () => isNon737Tail;

    // Effects
    // Log Page Number changed
    useEffect(() => {
        setLogPageNumber(logPageNumberInput);
        lastValidatedLogRef.current = logPageNumberInput;
    }, [logPageNumberInput]);

    // Item Number changed — only sync for non-737 (HA) tails
    useEffect(() => {
        if (isNon737Tail) {
            setItemNumber(itemNumberInput);
        }
    }, [itemNumberInput, isNon737Tail]);

    // Ata Chapter changed
    useEffect(() => {
      setAtachapter(ataChapterInput);
    }, [ataChapterInput]);
    
    useEffect(() => {
      setManufacturerInput(manufacturer);
    }, [manufacturer]);

    // Discrepancy Comments changed
    useEffect(() => {
      setDiscrepancyComments(discrepancyCommentsInput);
    }, [discrepancyCommentsInput]);

    // Correction Comments changed
    useEffect(() => {
      setCorrectionComments(correctioncommentsInput);
    }, [correctioncommentsInput]);

    // Mechanical Fail Indicator changed
    useEffect(() => {
      setMechanicalfailind(mechanicalfailindInput);
      console.log("mechanicalfailindInput: " + mechanicalfailindInput);
    }, [mechanicalfailindInput]);

    // Fleet changed
    useEffect(() => {
        setFleet(fleetInput);
    }, [fleetInput]);

    // Clear item number only when aircraft switches from non-737 → 737 (not on initial mount)
    useEffect(() => {
      if (!isNon737TailMountedRef.current) {
        isNon737TailMountedRef.current = true;
        return;
      }
      if (!isNon737Tail) {
        setItemNumber('');
        itemNumberChanged?.('');
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isNon737Tail]);

    // Trax Flight Number changed
    useEffect(() => {
        setTraxFlightNumber(traxFlightNumberInput);
    }, [traxFlightNumberInput]);

    //is Trax Data Mismatch value changed
    useEffect(() => {
        setIsTraxDataMismatch(traxDataMismatch)   
    }, [traxDataMismatch]);

    // Show Loader changed
    useEffect(() => {
      setLoading(showLoader);
    },[showLoader]);

    useEffect(() => {
      setIsLogNoValid(isLogPageValid);
  }, [isLogPageValid]);


  // Effect-based auto-refresh runs only after existing-record load completes.
  // User-triggered blur refresh behavior remains separate.
    useEffect(() => {
      const loadingJustCompleted = prevLoadingRef.current && !loading;
      prevLoadingRef.current = loading;

      if (!loadingJustCompleted) {
        return;
      }

      if (hasAutoRefreshedExistingRecordRef.current) {
        return;
      }

      // Only for non-737 tails
      if (!isNon737Aircraft()) {
        return;
      }

      // Only auto-refresh if both fields are populated and valid
      const hasLogNumber = logPageNumber && logPageNumber.trim() !== '';
      const hasItemNumber = itemNumber && itemNumber.trim() !== '';
      
      if (hasLogNumber && hasItemNumber && isLogNoValid && !busy && !loading) {
        const logPageNumberInput = logPageNumberInputRef.current;
        if (logPageNumberInput != null) {
          isAutoRefreshInProgressRef.current = true;
          logPageNumberInput.refresh();
          hasAutoRefreshedExistingRecordRef.current = true;
        }
      }
    }, [logPageNumber, itemNumber, isLogNoValid, busy, loading, isNon737Tail, manufacturerInput]);

    // Events
    // On Start Validation
    const handleStartValidation = () => {
      setBusy(true);                            
      logValidationChanged(true);
    }
    
    // On Complete Validation
    const handleCompleteValidation = (isValid: boolean, logPageNumber: string, logPageDetails?:DefectReport) => {
      const isAutoRefresh = isAutoRefreshInProgressRef.current;
      const isManualRefresh = isManualRefreshInProgressRef.current;
      isAutoRefreshInProgressRef.current = false;
      isManualRefreshInProgressRef.current = false;

      const isValueChanged = logPageNumber !== lastValidatedLogRef.current;
      lastValidatedLogRef.current = logPageNumber;

      logValidationChanged(isValid);
      logPageNumberChanged(logPageNumber);
      
      if (logPageDetails?.LogTailNbr !== undefined) {
        // Hydrate when:
        // - user clicked refresh button (isManualRefresh)
        // - user actually changed the log number value (isValueChanged)
        // Do NOT hydrate on:
        // - auto-refresh on initial load (would kill orange)
        // - simple focus/blur without editing (would kill orange)
        const shouldHydrate = isManualRefresh || (!isAutoRefresh && isValueChanged);
        console.log('TraxLogInfo.shouldHydrate', shouldHydrate);
        
        if (shouldHydrate) {
          console.log('TraxLogInfo: HYDRATING comments from TRAX');
          discrepancycommentsChanged(logPageDetails.LogDiscRmk);
          correctioncommentsChanged(logPageDetails.LogDefRmk);
          ataChapterChanged(logPageDetails.ATAChapter);
          traxFlightNumberChanged(logPageDetails.Flight);
          // Signal parent to re-compare after hydration
          // This ensures orange is re-evaluated with the new comment values
          if ((isManualRefresh || isValueChanged) && !isUserClearingMismatchRef.current) {
            onRefreshComplete?.();
          }
          isUserClearingMismatchRef.current = false;
        }
        if (defectTypeChanged) {
          // Always pass the latest value from API, default to 'OTHER' if empty or undefined
          defectTypeChanged(logPageDetails.DefectType && logPageDetails.DefectType.trim() !== '' ? logPageDetails.DefectType : 'OTHER');
        }
      }
      setBusy(false);
    }

    // Refs
    const logPageNumberInputRef = useRef<LogPageNumberInputHandle | null>(null);

    const refresh = () => {
      if(logPageNumberInputRef.current != null && logPageNumber) {
        isManualRefreshInProgressRef.current = true;
        logPageNumberInputRef.current.refresh();
      } else {
        console.log('TraxLogInfo.refresh(): ✗ Cannot refresh - missing ref or logPageNumber');
      }
    };

    const handleCorrectioncommentsChanged = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      setCorrectionComments(event.target.value);
      correctioncommentsChanged(event.target.value);
    };

    const handleDiscrepancycommentsChanged = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      setDiscrepancyComments(event.target.value);
      discrepancycommentsChanged(event.target.value); 
    }

    const handleItemNumberChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.currentTarget.value;
      setItemNumber(value);
      itemNumberChanged?.(value);
    };

    const handleAutoRefreshBlur = () => {

      // When parent tracks item focus (DelayEntry), it will trigger exactly one
      // compare call after blur. Skip local refresh here to avoid duplicate
      // PopulateLogDataFromTrax calls for the same log/item tuple.
      if (onItemFocusChanged) {
        return;
      }

      // For non-737 aircraft, auto-refresh when both log number and item number are populated
      if (isNon737Aircraft() && logPageNumber && logPageNumber.trim() !== '' && itemNumber && itemNumber.trim() !== '' && isLogNoValid) {
        refresh();
      }
    };

    const handleItemBlur = () => {
      onItemFocusChanged?.(false);
      handleAutoRefreshBlur();
    };

    const isControlDisabled = busy || loading || compareInProgress;
    // Render
    return (
    <>
      {/* Hidden DefectType field for API use */}
      <input type="hidden" value={defectType} data-testid="defectTypeHidden" />
      <div className="FlexSingleColumn TraxLogInfo" style={{ marginTop: ".75rem", marginBottom: ".5rem" }}>
        <div className="FlexSingleRow FullSize" style={{ marginBottom: ".25rem" }}>
          <div className="FlexSingleRow FullSize" style={{ flex: `1 1 calc(50% + ${ITEM_FIELD_WIDTH})` }}>
            
                  <LogPageNumberInput  
                    value={logPageNumber} 
                    ref={logPageNumberInputRef} 
                    manufacturer={manufacturerInput} 
                    isLogPageValid={isLogNoValid}
                    isNon737Tail={isNon737Aircraft()}
                    itemNumber={itemNumber}
                    onStartValidation={() => handleStartValidation()} 
                    disabled={isControlDisabled}
                    onFocusChanged={onLogFocusChanged}
                    onCompleteValidation={(isValid: boolean, logPageNumber: string, logPageDetails?:DefectReport) => handleCompleteValidation(isValid, logPageNumber, logPageDetails)}
                    onBlur={handleAutoRefreshBlur}
                  /> 
            
            {/* Item Number field - only show for non-737 aircraft */}
            {isNon737Aircraft() && (
              <div style={{ flex: `0 0 ${ITEM_FIELD_WIDTH}` }}>
                <DCInput
                  value={itemNumber}
                  maxLength={1}
                  placeholder="Item"
                  required={isNon737Aircraft()}
                  disable={isControlDisabled}
                  inputMode="numeric"
                  onInputChange={handleItemNumberChanged}
                  onFocus={() => onItemFocusChanged?.(true)}
                  onBlur={handleItemBlur}
                  isWarning={!isLogNoValid}
                />
              </div>
            )}

            <DCInput
              value={atachapter}
              maxLength={4}
              placeholder="ATA Code"
              required={false}
              disable={isControlDisabled}
              inputMode="numeric"
              onInputChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                ataChapterChanged(e.currentTarget.value)
              }/>
            <DCInput
              value={traxFlightNumber}
              maxLength={10}
              placeholder="Trax Flt Nbr"
              required={false}
              disable={isControlDisabled}
              onInputChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                traxFlightNumberChanged(e.currentTarget.value)
              }/>
          </div>
          <div className="FlexSingleRow relativePosition" style={{ flex: `1 1 calc(50% - ${ITEM_FIELD_WIDTH})` }}>
            {getAdminStatus().value || getMaintainerStatus().value ? 
            <auro-popover removeSpace for="btnRefresh">
                Refresh log info
              <auro-button
                id="btnRefresh"
                slim
                secondary
                slot="trigger"
                onClick={() => {
                  if (isTraxDataMismatch) {
                    isUserClearingMismatchRef.current = true;
                  }
                  onClearTraxMismatch?.();
                  refresh();
                }}
                disabled={isControlDisabled || !logPageNumber || !isLogNoValid || (isNon737Aircraft() && !itemNumber) ? "disabled" : undefined}
              >
                <auro-icon id={isTraxDataMismatch ? "orangeRefreshIcon" : "refreshIcon"} category="terminal" name="flight-changes" customColor />
              </auro-button>
            </auro-popover>
            : undefined
            }     
            <TraxLogInfoReport fleetInput={fleet} logPageNumberInput={logPageNumber} itemNumberInput={itemNumber} isNon737Tail={isNon737Aircraft() ?? false} disabled={isControlDisabled}/>       
          </div>
        </div>
        <div className="FlexSingleRow FullSize" style={{ marginBottom: ".25rem" }}>
          <DCTextArea
            maxLength={4000}
            value={discrepancycomments}
            placeholder="Discrepancy Remark"
            disable={isControlDisabled}
            onInputChange={handleDiscrepancycommentsChanged}
            spellcheck={false}
            onClickSave={onClickSave}
            
            />
        </div>
        <div className="FlexSingleRow FullSize" style={{ marginBottom: ".25rem" }}>
          <DCTextArea
            maxLength={4000}
            value={correctioncomments}
            placeholder="Deferred / Corrected Remark"
            disable={isControlDisabled}
            onInputChange={handleCorrectioncommentsChanged}
            onClickSave={onClickSave}
            spellcheck={false}
            />
        </div>
      </div>
    </>
  );
};
